import React from 'react';

import 'normalize.css';
import './styles/main.scss';
import Routes from './routes';

const App = () => <Routes />;

export default App;
